module.exports = __webpack_public_path__ + "img/fail.9e0dd63e.png";